const maintenanceEn = {
    asset: require('lang/en/maintenance/Asset').default,
    assetService: require('lang/en/maintenance/AssetService').default,
    assetInward: require('lang/en/maintenance/AssetInward').default,
    schedule: require('lang/en/maintenance/Schedule').default,
    jobCard: require('lang/en/maintenance/JobCard').default,
    workOrder: require('lang/en/maintenance/WorkOrder').default,
}

export default maintenanceEn;